export var EComparisonNotificationCategory;
(function (EComparisonNotificationCategory) {
  EComparisonNotificationCategory["Add"] = "add";
  EComparisonNotificationCategory["Limit"] = "limit";
  EComparisonNotificationCategory["Remove"] = "remove";
})(EComparisonNotificationCategory || (EComparisonNotificationCategory = {}));